import React, { useState, useEffect } from 'react';
import utils from '../utils/utils';
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import { NavLink, Redirect } from "react-router-dom";

function ProductBox({ session, setKey, ...props }) {

    const [price, setPrice] = useState(0);

    useEffect(() => {
        let variants = props.data.variants.sort((a, b) => a.price - b.price);
        setPrice(variants[0].price);
    }, []);

    return (
        <>
            <div className="product-box">
                <div className="row">
                    <div className="col">
                        <NavLink to={`/products/${props.data._id}`}>
                            <img src={props.data.images[0].fileUrl} className="product-box-image" />
                        </NavLink>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <span className="brand text-uppercase truncate-1 mt-10">{props.data.brandId.title}</span>
                        <span className="title truncate-2">{props.data.title}</span>
                        <span className="price">{utils.formatToCurrency(price, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</span>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductBox);